import React, { useEffect, useState } from "react";
import { Select, Card, Row, Col, Spin, message } from "antd";
import axios from "axios";

const { Option } = Select;

const ReflectionsDashboard = () => {
  const [classes, setClasses] = useState([]);
  const [activities, setActivities] = useState([]);
  const [students, setStudents] = useState([]);
  const [reflections, setReflections] = useState([]);
  const [loading, setLoading] = useState(false);

  const [selectedClass, setSelectedClass] = useState(null);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [selectedStudent, setSelectedStudent] = useState(null);

  // Load classes on mount
  useEffect(() => {
    axios.get("/api/classes")
      .then(res => setClasses(res.data))
      .catch(err => message.error("Fehler beim Laden der Klassen"));
  }, []);

  // Load activities when class changes
  useEffect(() => {
    if (!selectedClass) return;
    axios.get(`/api/classes/${selectedClass}/activities`)
      .then(res => setActivities(res.data))
      .catch(err => message.error("Fehler beim Laden der Aktivitäten"));
  }, [selectedClass]);

  // Load students when activity changes
  useEffect(() => {
    if (!selectedActivity) return;
    /*axios.get(`
      .then(res => setStudents(res.data))
      .catch(err => message.error("Fehler beim Laden der Schüler"));*/
  }, [selectedActivity]);

  // Load reflections when student changes
  useEffect(() => {
    if (!selectedStudent) return;
    /* setLoading(true);
    axios.get(`/api/students/${selectedStudent}/reflections`)
      .then(res => setReflections(res.data))
      .catch(err => message.error("Fehler beim Laden der Reflexionen"))
      .finally(() => setLoading(false));*/
  }, [selectedStudent]);

  return (
    <div style={{ padding: 20 }}>
      <Row gutter={[16, 16]}>
        <Col>
          <Select
            placeholder="Klasse wählen"
            style={{ width: 200 }}
            onChange={value => {
              setSelectedClass(value);
              setSelectedActivity(null);
              setSelectedStudent(null);
              setReflections([]);
            }}
            value={selectedClass}
          >
            {classes.map(cls => <Option key={cls.id} value={cls.id}>{cls.name}</Option>)}
          </Select>
        </Col>
        <Col>
          <Select
            placeholder="Aktivität wählen"
            style={{ width: 200 }}
            onChange={value => {
              setSelectedActivity(value);
              setSelectedStudent(null);
              setReflections([]);
            }}
            value={selectedActivity}
            disabled={!selectedClass}
          >
            {activities.map(act => <Option key={act.id} value={act.id}>{act.title}</Option>)}
          </Select>
        </Col>
        <Col>
          <Select
            placeholder="Schüler wählen"
            style={{ width: 200 }}
            onChange={value => setSelectedStudent(value)}
            value={selectedStudent}
            disabled={!selectedActivity}
          >
            {students.map(st => <Option key={st.id} value={st.id}>{st.name}</Option>)}
          </Select>
        </Col>
      </Row>

      <div style={{ marginTop: 20 }}>
        {loading ? (
          <Spin size="large" style={{ display: "block", margin: "50px auto" }} />
        ) : (
          <Row gutter={[16, 16]}>
            {reflections.map(ref => (
              <Col xs={24} sm={12} md={8} key={ref.id}>
                <Card title={ref.title || "Reflexion"} bordered>
                  <p>{ref.content}</p>
                  <small>{new Date(ref.created_at).toLocaleDateString()}</small>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </div>
    </div>
  );
};

export default ReflectionsDashboard;